import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'

const HeroSection = () => {
  return (
    <div className="relative min-h-screen flex flex-col justify-center pt-40 pb-16 overflow-hidden">
      {/* Background with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center transition-transform duration-10000 hover:scale-110" 
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?q=80&w=2000')" }}
      >
        <div className="absolute inset-0 bg-cidh-blue/70 mix-blend-multiply"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-white">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <span className="inline-block bg-cidh-gold/20 text-cidh-gold px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-6 border border-cidh-gold/30">
            Expertise & Conseil
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 font-montserrat leading-tight">
            Accompagner l'Excellence pour un <span className="text-cidh-gold">Développement Durable</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-10 leading-relaxed font-light">
            CIDH Consulting SARL vous offre des solutions d'ingénierie en développement humain, études et assistance technique.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/programmes" className="btn-primary flex items-center justify-center gap-2 group">
              Découvrir nos programmes <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link to="/a-propos/presentation" className="bg-white/10 backdrop-blur-md text-white border border-white/20 px-6 py-3 rounded-md font-semibold hover:bg-white/20 transition-all text-center">
              En savoir plus sur nous
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent"></div>
    </div>
  )
}

export default HeroSection
